<table class="bk-event-table bk-flowmeter">
	<thead>
		<tr>
			<th class="bk-event-table__header bk-flowmeter__header">
				{{'Start' | translate }}
			</th>
			<th class="bk-event-table__header bk-flowmeter__header">
				{{'End' | translate }}
			</th>
			<th class="bk-event-table__header bk-flowmeter__header">
				{{'Average Flow Rate' | translate }} ({{'gpm' | translate }})
			</th>
			<th class="bk-event-table__header bk-flowmeter__header">
				{{'Gallons' | translate }}
			</th>
			<th class="bk-event-table__header bk-flowmeter__header">
				{{'Time' | translate }}
			</th>
			<th class="bk-event-table__header bk-flowmeter__header">
				{{'Applied Flowmeter Water' | translate }} ({{'in' | translate }})
			</th>
			<th class="bk-event-table__header bk-flowmeter__header">
				{{'Application Rate' | translate }} ({{'in/hr' | translate }})
			</th>
			<th class="bk-event-table__header bk-flowmeter__header">
				{{'Flowmeter Area' | translate }} ({{'acres' | translate }})
			</th>
		</tr>
	</thead>
	<tbody>
		<tr class="bk-event-table__row" *ngFor="let data of flowmeterData" (click)="loadDetails(data.Id)">
			<td class="bk-event-table__cell bk-flowmeter__cell">{{data.StartDate}}</td>
			<td class="bk-event-table__cell bk-flowmeter__cell">{{data.EndDate}}</td>
			<td class="bk-event-table__cell bk-flowmeter__cell">{{data.AvgFlow}}</td>
			<td class="bk-event-table__cell bk-flowmeter__cell">{{data.Gallons}}</td>
			<td class="bk-event-table__cell bk-flowmeter__cell">{{data.Time}}</td>
			<td class="bk-event-table__cell bk-flowmeter__cell">{{data.Applied}}</td>
			<td class="bk-event-table__cell bk-flowmeter__cell">{{data.AppRate}}</td>
			<td class="bk-event-table__cell bk-flowmeter__cell">{{data.SprinklerArea > 0 ? data.SprinklerArea : 'N/A'}}</td>
		</tr>
	</tbody>
</table>